import { CheckCircle2 } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtDateTime } from "../../../lib/format";
import { useBlobUrl } from "../../../lib/xutil";
import { useApi } from "../hooks";

export const DeliveryProof = ({ localId }) => {
  const { t } = useI18n();
  const r = useApi("orderPod", `/orders/${localId}/pod`, undefined, { retry: false, staleTime: 60000 });
  const photo = useBlobUrl(r.data?.photo_file_id);
  const sig = useBlobUrl(r.data?.signature_file_id);
  if (!r.data) return null;
  return (
    <section className="rounded-2xl bg-white p-4 shadow-sm" data-testid="order-pod">
      <h2 className="flex items-center gap-2 text-base font-semibold text-navy md:text-lg"><CheckCircle2 className="h-5 w-5 text-brand" />{t("x.pod.title")}</h2>
      <p className="mt-1 text-sm text-slate-600" data-testid="order-pod-receiver">{t("x.route.receivedBy", { name: r.data.receiver_name })} · {fmtDateTime(r.data.at)}</p>
      <div className="mt-3 grid grid-cols-2 gap-3">
        {photo && <a href={photo} target="_blank" rel="noreferrer" data-testid="order-pod-photo"><img src={photo} alt={t("x.route.pod.photo")} className="h-36 w-full rounded-xl object-cover" /></a>}
        {sig && <div className="grid place-items-center rounded-xl border border-slate-100 bg-white p-2" data-testid="order-pod-signature"><img src={sig} alt={t("x.route.pod.signature")} className="max-h-32" /></div>}
      </div>
    </section>
  );
};
